import { PaymentMethod } from "../../Enums/PaymentMethod";
import { FaEye } from "react-icons/fa";
import SelectableBox from "../SelectableBox/SelectableBox";

type InStorePaymentStepProps = {
  selectedPaymentMethod: PaymentMethod | null;
  onSelectPaymentMethod: (method: PaymentMethod) => void;
  enablePix: boolean;
  enableBankingBillet: boolean;
  enableCreditCard: boolean;
};

const InStorePaymentStep = ({
  selectedPaymentMethod,
  onSelectPaymentMethod,
  enablePix,
  enableBankingBillet,
  enableCreditCard,
}: InStorePaymentStepProps) => {
  const options: { method: PaymentMethod; label: string }[] = [
    { method: PaymentMethod.Cash,                      label: "Dinheiro" },
    ...(enablePix                       ? [{ method: PaymentMethod.Pix,                       label: "PIX" }] : []),
    ...(enableBankingBillet             ? [{ method: PaymentMethod.BankingBillet,             label: "Boleto Bancário" }] : []),
    ...(enableCreditCard                ? [{ method: PaymentMethod.CreditCard,                label: "Cartão de Crédito" }] : []),
  ];

  return (
    <div className="flex flex-col bg-white border p-4 gap-5 flex-[1.6] rounded shadow">
      <div className="flex items-center gap-2">
        <FaEye className="text-primary-600" />
        <h3 className="font-bold">{"FORMA DE PAGAMENTO"}</h3>
      </div>

      <div className="space-y-4">
        {options.map(({ method, label }) => (
          <SelectableBox
            key={method}
            id={String(method)}
            label={label}
            selected={selectedPaymentMethod === method}
            onSelect={() => onSelectPaymentMethod(method)}
          />
        ))}
      </div>
    </div>
  );
};

export default InStorePaymentStep;
